import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { Button } from 'react-bootstrap';
import Configuration from '../../../common/Configuration.json';
import AddressIdUtil from '../../../common/AddressIdUtil';
import SectionHeading from '../../SectionHeading/SectionHeading';
import SubSection from '../../SubSection/SubSection';
import PlanUtilities from '../../../services/PlanService';
import './Summary.scss';
import CreditSummary from '../../creditsummary/CreditSummary';
import SubscriptionDiscountService from '../../../services/SubscriptionDiscountService';
import PlanIdUtil from '../../../common/PlanIdUtil';
import CheckImage from '../../../components/InfoBox/Check.svg';

const getPriceText = (price, isZeroFree) => {
  if (isZeroFree) {
    return price > 0 ? `$${price}` : 'FREE';
  }
  return `$${price}`;
};

const getTotalToPayContent = (charges, giftWithPurchase) => {
  const totalToPay = [{
    leftContent: <p className="plan-summary-text">Connection fee</p>,
    rightContent: <p className="plan-summary-text">{getPriceText(charges.connectionCost, true)}</p>
  }, !charges.isByoModemSelected && {
    leftContent: <p className="plan-summary-text">{Configuration.modemName}</p>,
    rightContent: <p className="plan-summary-text">{getPriceText(charges.modemCost, true)}</p>
  }, !charges.isByoModemSelected && {
    leftContent: <p className="plan-summary-text">Shipping and handling fee</p>,
    rightContent: <p className="plan-summary-text">{getPriceText(charges.shippingCost, true)}</p>
  }, {
    leftContent: <p className="plan-summary-text">Total</p>,
    rightContent:
      <p className="plan-summary-text">
        {getPriceText(charges.total, false)}
      </p>,
    emphasise: true
  }];
  if (giftWithPurchase.enabled) {
    totalToPay.splice(1, 0, {
      leftContent: <p className="plan-summary-text">{giftWithPurchase.name}</p>,
      rightContent: <p className="plan-summary-text">{getPriceText(0, true)}</p>
    });
  }
  if (charges.discountApplied) {
    totalToPay.splice(2, 0, {
      leftContent: <p className="plan-summary-text line-item-highlight">Discount</p>,
      rightContent:
        <p className="plan-summary-text line-item-highlight">
          -{getPriceText(charges.discountApplied, true)}
        </p>
    });
  }
  return totalToPay;
};

const onLinkClick = onClick => (event) => {
  event.preventDefault();
  onClick();
};

const Summary = (props) => {
  const charges = PlanUtilities.getChargeSummary(
    props.isContractSelected,
    props.connectionPrice,
    props.shippingPrice,
    props.modemPrice,
    props.discount,
    props.isByoModemSelected
  );

  const validateNextButton = (isByoModemSelected, isImportantInfoTickbox) => {
    const elem = document.querySelector('.importantinfo-tickbox');
    if (isByoModemSelected) {
      if (!isImportantInfoTickbox) {
        const elemError = document.querySelector('.importantinfo-tickbox .form-validation-message');
        elemError.innerHTML = '<div className="form-validation-message">Please ensure you understand and want to use your own modem</div>';
        elem.scrollIntoView();
        return false;
      }
    }
    browserHistory.push('/checkout');
    return true;
  };

  if (!props.selectedPlan) {
    window.location = Configuration.homeUrl;
    return null;
  }
  const credit = PlanUtilities.getCredit(props.selectedPlan.isContract);
  return (
    <div>
      <div className="summary-container">
        <SectionHeading
          number={5}
          title={'Summary'}
          className={'summary-heading'}
          titleClassName={'summary-heading-title'}
          numberClassName={'summary-heading-number'}
        />
        <SubSection
          title={'Your address'}
          content={[{
            leftContent: <p className="plan-summary-text">{props.address}</p>
          }, {
            leftContent:
              <a
                className="summary-clear-address"
                href="/"
                onClick={onLinkClick(AddressIdUtil.changeAddress(props.resetAddressSearch))}
              >
                Change
              </a>
          }]}
        />
        <SubSection
          title={'Monthly plan'}
          content={[{
            leftContent: (
              <div>
                <p className="plan-summary-text">{`${props.selectedPlan.label}`}</p>
                <a
                  className="summary-clear-address summary-change-plan"
                  href="/"
                  onClick={onLinkClick(AddressIdUtil.changeAddress(props.resetAddressSearch))}
                >
                Change
                </a>
                <div className="summary-space" />
                {props.withMobileDiscount && (
                  <p className="plan-summary-text">
                    <img
                      src={CheckImage}
                      className="check check-orange"
                      height="10"
                      alt="Check"
                      role="presentation"
                    /> Skinny Mobile Plan Discount</p>
                )}
                <p className="plan-summary-text">
                  <img
                    src={CheckImage}
                    className="check check-orange"
                    height="10"
                    alt="Check"
                    role="presentation"
                  /> {props.contractType} contract&nbsp;
                  <b className="line-item-highlight">
                    {
                      SubscriptionDiscountService.getDescription(
                        props.isContractSelected,
                        props.discountWithSubscription)
                    }
                  </b>
                </p>
                {props.isByoModemSelected && (
                  <p className="plan-summary-text">
                    <img
                      src={CheckImage}
                      className="check check-orange"
                      height="10"
                      alt="Check"
                      role="presentation"
                    /> BYO Modem Discount</p>
                )}
              </div>
            ),
            rightContent: <p className="plan-summary-text">&nbsp;</p>
          },
            /* ...props.withMobileDiscount ? [{
              leftContent: <p className="plan-summary-text">Plan price</p>,
              rightContent: <p className="plan-summary-text">${props.selectedPlan.price}</p>
            }, {
              leftContent: <p className="plan-summary-text">{Configuration.skinnyMobileCustomerDiscount.name}</p>,
              rightContent: <p className="plan-summary-text">{Configuration.skinnyMobileCustomerDiscount.amountText}</p>
            }] : [],*/
            {
              leftContent:
                <p className="plan-summary-text">
                  {
                    SubscriptionDiscountService.getPaymentMessage(
                      props.isContractSelected,
                      props.discountWithSubscription)
                  }
                </p>,
              rightContent: <p className="plan-summary-text">${PlanIdUtil.getPlanPrice((props.isByoModemSelected ? (props.selectedPlan.price - props.byoModemDiscountPrice) : props.selectedPlan.price), props.withMobileDiscount ? [Configuration.skinnyMobileCustomerDiscount.amount] : [])}</p>,
              emphasise: true
            },
            props.isByoModemSelected ? {
              leftContent: <p className="plan-summary-text">After 12 months</p>,
              rightContent: <p className="plan-summary-text">${PlanIdUtil.getPlanPrice(props.selectedPlan.price, props.withMobileDiscount ? [Configuration.skinnyMobileCustomerDiscount.amount] : [])}</p>,
              emphasise: true
            } : {}
          ]}
        />
        {credit &&
        <CreditSummary credit={credit} price={props.selectedPlan.price} />
        }
        <SubSection
          title={'Total to pay now'}
          content={
            getTotalToPayContent(charges, props.giftWithPurchase)
          }
        />
        <Button
          type="submit"
          className={'next-btn'}
          id="change-next"
          onClick={() => validateNextButton(props.isByoModemSelected, props.isImportantInfoTickbox)}
          events={[
            { category: 'plan', action: 'home-next', label: props.selectedPlan.name },
            { category: 'contract', action: 'home-next', label: props.contractType }
          ]}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

Summary.propTypes = {
  address: PropTypes.string,
  contractType: PropTypes.string,
  selectedPlan: PropTypes.object,
  modemPrice: PropTypes.number,
  shippingPrice: PropTypes.number,
  connectionPrice: PropTypes.number,
  isContractSelected: PropTypes.bool,

  resetAddressSearch: PropTypes.func,
  giftWithPurchase: PropTypes.object,
  discount: PropTypes.object,
  discountWithSubscription: PropTypes.object,
  withMobileDiscount: PropTypes.bool,
  isByoModemSelected: PropTypes.bool,
  isImportantInfoTickbox: PropTypes.bool,
  byoModemDiscountPrice: PropTypes.number
};

export default Summary;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/Summary/Summary.js
 **/